<template>
    <div>
        <label :for="id" class="block text-sm font-medium text-gray-700">
            <slot>WASAUCHIMMER</slot>
        </label>

        <div class="ml-2">
            <h2 :for="id" class="block text-sm font-medium text-gray-700">
                Ausgewählt
            </h2>

            <div class="h-64 overflow-y-scroll border p-2 rounded">
                <p v-show="selected.length === 0">Keine Auswahl getroffen.</p>
                    <a v-for="item in selected"
                   @click="toggle(item.id)"
                   class="m-2 inline-flex rounded-full items-center justify-center  px-2 pr-1 text-sm text-center font-medium bg-office-primary text-white" >
                    <button type="button"
                            class="flex-shrink-0  m-1 h-4 w-4 rounded-full inline-flex items-center justify-center hover:bg-yellow-500  focus:outline-none focus:ring-2 ring-white text-white">
                        <span class="sr-only">löschen</span>
                        <i class="fa fa-times px-3 "></i>
                    </button>
                    {{ item.text }}
                </a>
            </div>
        </div>  

        <div class="ml-2 mt-2">
            <h2 :for="id" class="block text-sm font-medium text-gray-700">
                Auswählbar
            </h2>

            <div class="relative py-2">
                <input
                    v-model="search"
                    name="q"
                    class="focus:outline-none p-2 pl-10 rounded bg-grey-200 w-full focus:bg-white border focus:border-blue-800"
                    type="text"
                    aria-label="Searchbox"
                    placeholder="Suche"
                    autocomplete="off"
                    ref="qfield"
                >
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center text-grey">
                    <i class="fa fa-search"></i>
                </div>
                <div
                    v-show="search.length > 0"
                    @click="search = ''"
                    class="cursor-pointer absolute inset-y-0 right-0 pr-3 flex items-center text-grey"
                >
                    <i class="fa fa-times"></i>
                </div>
            </div>

            <div class="h-64 overflow-y-scroll border p-2 rounded">
                <ul v-show="unselected.length > 0" class=" flex flex-row">
                    <li v-for="item in unselected">
                        <a @click="toggle(item.id)"
                           :class="{'bg-office-primary': isNotActive(item.id)}"
                           class="m-2 inline-flex rounded-full items-center  px-2 pr-1 text-sm font-medium bg-yellow-600">
                            <button type="button"
                                    class="flex-shrink-0  m-1 h-4 w-4 rounded-full inline-flex items-center justify-center hover:bg-yellow-500  focus:outline-none focus:ring-2 ring-white  text-white">
                                <span class="sr-only">hinzufügen</span>
                                <i class="fa fa-plus"></i>
                            </button>
                            <p class="text-white mr-2">{{ item.text }}</p>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import uniqueId from 'lodash/uniqueId';
import keyBy from 'lodash/keyBy';
import sortBy from 'lodash/sortBy';
import InputText from "./InputText";
import includes from "lodash/includes";

export default {
    name: "MultiSelect",
    components: {InputText},
    props: ['value', 'selectable'],

    data: () => ({
        search: '',
    }),

    computed: {
        id: () => uniqueId(),
        tmp() {
            return keyBy(this.selectable, 'id');
        },
        selected() {
            return sortBy(
                this.value.map((id) => this.tmp[id]).filter(v => v !== undefined),
                'text'
            );
        },
        unselected() {
            return this.selectable.filter((item) => {
                return includes(item.text.toLowerCase(), this.search.toLowerCase());
            });
        }
    },

    methods: {
        isNotActive(id) {
            return !this.value.includes(id);
        },
        toggle(id) {
            if (!this.value.includes(id)) {
                return this.append(id);
            }

            let key = this.value.indexOf(id);
            return this.deselect(key);
        },
        deselect(key) {
            let val = this.value;
            val.splice(key, 1);
            this.$emit('input', val);
        },
        append(id) {
            let val = this.value;
            val.push(id);
            this.$emit('input', val);
        }
    }


}
</script>

<style scoped>

</style>